import React from "react";
import {ColumnDivF1, RowDiv, RowDivF1} from "../styledComponents/CustomStyledComponents";
import {CountryReportInfo} from "../../interfaces/RankingsAndLevelsInterfaces";
import GraphicBox from "./Components/GraphicBox";
import GeneralInfoBox from "./Components/GeneralInfoBox";
import GraphicsInfoBox from "./Components/GraphicsInfoBox";
import RankingComponent from "./Components/RankingComponent";
import {useTranslation} from "react-i18next";


const InfoBoxes: React.FC<{countryLastReportData: any}> = ({countryLastReportData}) => {
    return (
        <React.Fragment>
            <div className='infoBoxWrapper'>
                <GraphicsInfoBox
                    showLinkButton={false}
                    customStyle={{flex: 1, paddingLeft: 30, paddingRight: 10, paddingTop: 20, paddingBottom: 40, marginTop: 35}}
                    countryInfo={countryLastReportData}
                />
            </div>
            <div className='infoBoxWrapper'>
                <GeneralInfoBox
                    customStyle={{flex: 1, marginTop: 40, paddingLeft: 30, paddingRight: 10, paddingTop: 20, paddingBottom: 40}}
                    countryInfo={countryLastReportData}
                />
            </div>
        </React.Fragment>
    )
};

const FirstRowGraphics: React.FC<{last5YearsData: any}> = ({last5YearsData}) => {
    const { t } = useTranslation();

    return (
        <RowDivF1 style={{alignItems: "center", paddingLeft: 60}}>
        <div className='graphicBoxContainer'>
            <GraphicBox
                title={t('countryContainer.infoBox.evolutionPBI')}
                countryAllReportData={last5YearsData}
                keyData='gdp'
                unit='$'
            />
        </div>
        <div className='graphicBoxContainer'>
            <GraphicBox
                title={t('countryContainer.infoBox.evolutionGIP')}
                countryAllReportData={last5YearsData}
                keyData='gip'
            />
        </div>
    </RowDivF1>
    )
};

const SecondRowGraphics: React.FC<{last5YearsData: any, countryLastReportData: any }> = ({last5YearsData, countryLastReportData}) => {
    const { t } = useTranslation();

    return (
        <RowDivF1 style={{alignItems: "center", paddingLeft: 60}}>
            <div className='graphicBoxContainer'>
                <GraphicBox
                    title={t('countryContainer.infoBox.gaiEvolution')}
                    countryAllReportData={last5YearsData}
                    keyData='gai'
                />
            </div>
            <div className='fillableCircleWrapper'>
                <RowDiv>
                    <RankingComponent title={t('countryContainer.infoBox.rankingUpper')} rankingValue={countryLastReportData?.gip_ranking} />
                </RowDiv>
                <RowDiv>
                    <RankingComponent title={t('countryContainer.infoBox.rankingGaiUpper')} rankingValue={countryLastReportData?.gai_ranking} />
                </RowDiv>
            </div>
        </RowDivF1>
    )
};



const CountryGraphicsComponent: React.FC<{countryInfo: CountryReportInfo | undefined }> = ({countryInfo = {}}) => {
    const { countryLastReportData, countryAllReportData } = countryInfo;
    let last5YearsData: any = {};
    if(countryAllReportData && Object.keys(countryAllReportData).length){
        const last5Years = Object.keys(countryAllReportData).sort().slice(-5);
        last5Years.forEach((year: string) => {
            last5YearsData[year] = countryAllReportData[year];
        });
    }

    return (
        <div className='graphicsContainer' id='CountryGraphicsComponent' >
            <ColumnDivF1 className='infoBoxContainer' style={{flex: '1 1 33%', height: '100%'}}>
                <InfoBoxes countryLastReportData={countryLastReportData}/>
            </ColumnDivF1>
            <ColumnDivF1 style={{flex: '2 1 66%', height: '100%'}}>
                <FirstRowGraphics last5YearsData={last5YearsData}/>
                <SecondRowGraphics last5YearsData={last5YearsData} countryLastReportData={countryLastReportData}/>
            </ColumnDivF1>
        </div>
    )
};

export default CountryGraphicsComponent;
